import { useMemo } from 'react';

import { GetAllSites } from '@/api/fe-api/view/queries/get-all-sites';
import { FieldSelect } from '@/components/looker/field-select';
import { useMe } from '@/hooks/use-me';
import type { Top } from '@/task-manager/entities/top';
import { siteId } from '@/utils/format/customer';
import { singular } from '@/utils/format/label';

export type TopFilterProps = {
  value?: string;
  onChange: (value?: string) => void;
};

export function TopFilter({ value, onChange }: TopFilterProps) {
  const me = useMe();
  const listTops = GetAllSites.useQuery();

  const selectedTop = useMemo<Top | undefined>(
    () =>
      listTops.data?.find(({ fullFrontendId }) => fullFrontendId === value) ??
      undefined,
    [value, listTops.data],
  );

  return (
    <FieldSelect
      isFilterable={true}
      label={singular(me.config.top.labels.name)}
      placeholder={`Filter by ${singular(me.config.top.labels.name)}`}
      value={selectedTop?.name}
      options={
        listTops.data?.map(({ fullFrontendId }) => ({
          value: fullFrontendId,
        })) ?? []
      }
      onChange={(name) => onChange(name !== '' ? siteId(name) : undefined)}
    />
  );
}
